import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Col, Row, Button, Modal, Card, CardHeader, Label } from 'reactstrap';
import { Form } from '@availity/form';
import '@availity/yup';
import { NavLink, Redirect } from 'react-router-dom';
import axios from 'axios';
import { FaFilePdf, FaFileWord, FaFileExcel, FaFile } from 'react-icons/fa';

import CustomProgressBar from '../../../Common/components/CustomProgressBar';
import awardeestore from '../../stores/awardeestore';

@observer
export default class UploadVoucherReviewSubmit extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      redirectToProviderAwardee: false,
      redirectUploadDocuments: false
    }

    if(awardeestore.getAwardeeUploadDocPageStatus('#uploadReviewAndSubmit') !== 'stepwizard-step active') {
      awardeestore.setUploadAwardeeHousingPageStatus('#uploadReviewAndSubmit', 'active');
    }

    if(window.performance) {
      if(performance.navigation.type == 1) {
        awardeestore.resetUploadAwardeeHousingPageStatus()
        window.location.href = '#';
      }
    }
  }

  printPage = () => {
    const hideBtns1 = document.querySelector('#hideEdit1');
    const hideBtns2 = document.querySelector('#hideEdit2');
    const hideBtns3 = document.querySelector('#hideBtns');

    hideBtns1.style.visibility = 'hidden';
    hideBtns2.style.visibility = 'hidden';
    hideBtns3.style.visibility = 'hidden';

    const content = document.querySelector('#uploadReviewSubmitContent');
    const pri = document.querySelector('#ifmcontentstoprint').contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();

    hideBtns1.style.visibility = 'visible';
    hideBtns2.style.visibility = 'visible';
    hideBtns3.style.visibility = 'visible';
  }

  handleSubmit = () => {
    const { history } = this.props;
    const postUrl = '/ahahawardeeprofileform/wa/api/v1/provconn/survey/tpa/submit';
    const data = awardeestore.getUploadVoucherFormData();
    awardeestore.turnOnBlocking();
    axios({
      method: 'post',
      url: postUrl,
      data: data
    }).then(res => {
      if(res.status === 200 && res.data.confirmationNbr) {
        awardeestore.confirmationId = res.data.confirmationNbr;
         awardeestore.completedSteps.uploadReviewAndSubmit=true;
        this.props.history.push('/uploadvoucherconfirmation');
      } else {
        awardeestore.incrementSubmissionErrorCount();
        awardeestore.openErrorModal();
      }
      awardeestore.turnOffBlocking();
    }).catch(error => {
      awardeestore.incrementSubmissionErrorCount();
      awardeestore.openErrorModal();
      awardeestore.turnOffBlocking();
    })
  }

  componentDidMount() {
    window.onpopstate = () => {
      this.props.history.go(1);
    }
  }

  goBack = () => {
    this.setState({redirectUploadDocuments: true});
  }

  goToProviderAwardee = () => {
    this.setState({redirectToProviderAwardee: true});
  }

  closeModal = () => {
    awardeestore.closeErrorModal();
  }

  openModal = () => {
    awardeestore.openErrorModal();
  }

  getFileIcon = (fileName) => {
    if(!fileName) {
      return <FaFile />
    }
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return <FaFilePdf />;
      case 'doc':
      case 'docx':
        return <FaFileWord />;
      case 'xls':
      case 'xlsx':
        return <FaFileExcel />;
      default:
        return <FaFile />
    }
  }

  onClickErrorBtnOk = () => {
    const { history } = this.props;
    if(awardeestore.submissionErrorCount >= awardeestore.definedErrorCount) {
      history.push('/');
      window.location.reload();
    }
    awardeestore.closeErrorModal();
  }

  render() {
    const { redirectUploadDocuments, redirectToProviderAwardee } = this.state;
    const { 
      uploadAwardeeHousingPages,
      providerInformation,
      awardeeInformation,
      showErrorModal,
      submissionErrorCount,
      definedErrorCount,
      documentUploadDetails
    } = awardeestore;

    const {
      agencyName,
      contactFirst,
      contactLast,
      contactEmail,
      contactPhone
    } = providerInformation;

    const providerAgencyNameTmp = awardeestore.getProvAgencyName(providerInformation);

    const { 
      awardeeFirst,
      awardeeLast,
      awardeeDOB,
      awardeeProvOneId
    } = awardeeInformation;

    if(redirectToProviderAwardee) {
      return <Redirect to='/providerAndAwardee' />
    }

    if(redirectUploadDocuments) {
      return <Redirect to='/documentsVoucher' />
    }

    const iframeStyle = {
      height: '0px',
      width: '0px',
      position: 'absolute'
    }

    return (
      <div className='border-form'>
        <Modal className='errorModal' isOpen={showErrorModal} toggle={this.onClickErrorBtnOk}>
          <Card>
            <CardHeader className='errorPopup d-flex justify-content-center flex-column align-items-center center-text'>
              <>
                <h5>
                  <b>
                    The assessment has failed to send.
                  </b>
                </h5>
                <div className='spacer' />
                {submissionErrorCount >= definedErrorCount ? <h6>Please try again sometime later.</h6> : <h6>Hit <b>submit</b> again</h6>}
                <Button className='errCloseBtn' onClick={this.onClickErrorBtnOk} type='button' color="default">
                  OK
                </Button>
              </>
            </CardHeader>
          </Card>
        </Modal>
        <CustomProgressBar pages={uploadAwardeeHousingPages} />
        <div className='spacer-48' />
        <iframe title='Review_Submit_Frame' id='ifmcontentstoprint' style={iframeStyle} />
        <div id='uploadReviewSubmitContent'>
          <Row>
            <Col sm='7'>
              <h2 className='poppinsH2'>
                Review and Submit
              </h2>
            </Col>
          </Row>
          <div className='spacer-48' />
          <Row>
            <Col sm='10'>
              <h4 className='poppinsH5 mb-25'>
                Provider &amp; Awardee Information
              </h4>
              <h5 className='fs-22'>Provider Information</h5>
            </Col>
            <Col id='hideEdit1' sm='2'>
              <Button 
                className="editFromRevndSubChild" 
                color='link' 
                name="providerAwardeeInfo"
                onClick={this.goToProviderAwardee}>
                Edit
              </Button>
            </Col>
          </Row>
          <div className='spacer' />
          <Row>
            <Col sm="4">
              <Label className='label-font' hmtlFor='reviewProvAgency'>
                <b>Provider Agency Name</b>
              </Label>
              <p name="reviewProvAgency" className='label-font'>
                {providerAgencyNameTmp}
              </p>
            </Col>
            <Col sm='4'>
              <Label className='label-font' htmlFor='reviewContactFirst'>
                <b>Provider Contact First Name</b>
              </Label>
              <p name="reviewProvContactFirst" className='label-font'>
                {contactFirst}
              </p>
            </Col>
            <Col sm='4'>
              <Label className='label-font' htmlFor='reviewContactLast'>
                <b>Provider Contact Last Name</b>
              </Label>
              <p name='reviewContactLast' className='label-font'>
                {contactLast}
              </p>
            </Col>
          </Row>

          <div className='spacer' />

          <Row>
            <Col sm='4'>
              <Label className='label-font' htmlFor='reviewEmail'>
                <b>Email</b>
              </Label>
              <p name='reviewEmail' className='label-font'>
                {contactEmail}
              </p>
            </Col>
            <Col sm='4'>
              <Label className='label-font' htmlFor='reviewPhone'>
                <b>Phone</b>
              </Label>
              <p name='reviewPhone' className='label-font'>
                {contactPhone}
              </p>
            </Col>
          </Row>

          <Row>
            <Col sm='10'>
              <h5 className='fs-22'>Awardee Information</h5>
            </Col>
          </Row>

          <Row>
            <Col sm='4'>
              <Label className='label-font' htmlFor='reviewAwardeeFirst'>
                <b>First Name</b>
              </Label>
              <p name='reviewAwardeeFirst' className='label-font'>
                {awardeeFirst}
              </p>
            </Col>
            <Col sm='4'>
              <Label className='label-font' htmlFor='reviewAwardeeLast'>
                <b>Last Name</b>
              </Label>
              <p name='reviewAwardeeLast' className='label-font'>
                {awardeeLast}
              </p>
            </Col>
          </Row>

          <Row>
            <Col sm='4'>
              <Label className='label-font' htmlFor='reviewDateOfBirth'>
                <b>Date of Birth</b>
              </Label>
              <p name='reviewDateOfBirth' className='label-font'>
                {awardeeDOB}
              </p>
            </Col>
            <Col sm='4'>
              <Label className='label-font' htmlFor='reviewProviderOne'>
                <b>ProviderOne Number</b>
              </Label>
              <p name='reviewProviderOne' className='label-font'>
                {`${awardeeProvOneId}WA`}
              </p>
            </Col>
          </Row>

          <div className='spacer' />

          <hr className='mtb-35' />

          <Row>
            <Col sm='10'>
              <h4 className='poppinsH5 mb-25'>
                Uploaded Documents
              </h4>
              <h5 className='fs-22'>Voucher Packet</h5>
            </Col>
            <Col id='hideEdit2' sm='2'>
              <Button 
                className="editFromRevndSubChild" 
                color='link' 
                name="documentUpload"
                onClick={this.goBack}>
                Edit
              </Button>
            </Col>
          </Row>

          <div className='label-font' name='voucher-docs'>
            {documentUploadDetails.map((doc, i) => (
              (doc.fileName && i < 9) ?
              <Row className="mt-3 mb-5">
                  <Col sm="6">
                      <Label className="label-font label-font-sub">
                          {doc.documentName}
                      </Label>
                  </Col>
                  <Col sm="6" >
                      <Label className="label-font label-font-sub">
                          {this.getFileIcon(doc.fileName)} &nbsp;
                          {doc.fileName}
                      </Label>
                  </Col>
              </Row>
              :
              ((doc.fileName && i === 9) &&
                <>
                  <div key='voucherOther'>
                    <span>
                      <i className='icon icon-check' />
                      Other
                    </span>
                  </div>
                  <Row className="mt-3 mb-5">
                    <Col sm="6">
                        <Label className="label-font label-font-sub">
                          {doc.customDocumentName}
                        </Label>
                    </Col>
                    <Col sm="6" >
                        <Label className="label-font label-font-sub">
                            {this.getFileIcon(doc.fileName)} &nbsp;
                            {doc.fileName}
                        </Label>
                    </Col>
                  </Row>
                </>
              )
            ))}
          </div>

          <Row className='mt-1hfrem'>
            <Col sm='10'>
              <h5 className='fs-22'>Landlord Packet</h5>
            </Col>
          </Row>

          <div className='label-font' name='reviewDocumentsLandlordPacket'>
            {documentUploadDetails.map((doc, i) => (
              (doc.fileName && i > 9 && i < 15) ?
              <Row className="mt-3 mb-5">
                <Col sm="6">
                    <Label className="label-font label-font-sub">
                        {doc.documentName}
                    </Label>
                </Col>
                <Col sm="6" >
                    <Label className="label-font label-font-sub">
                        {this.getFileIcon(doc.fileName)} &nbsp;
                        {doc.fileName}
                    </Label>
                </Col>
              </Row>
              :
              ((doc.fileName && i === 15) && 
                <>
                  <div key='landlordOther'>
                    <span>
                      <i className='icon icon-check' />
                      Other
                    </span>
                  </div>
                  <Row className="mt-3 mb-5">
                    <Col sm="6">
                        <Label className="label-font label-font-sub">
                          {doc.customDocumentName}
                        </Label>
                    </Col>
                    <Col sm="6" >
                        <Label className="label-font label-font-sub">
                            {this.getFileIcon(doc.fileName)} &nbsp;
                            {doc.fileName}
                        </Label>
                    </Col>
                  </Row>
                </>
              )
            ))}
          </div>
          
          <div className='mt-1hfrem' />

          <Row id='hideBtns'>
            <Col>
              <Button type="button" color={"primary"} className='btn btn-primary straighten-borders buttonBack mb-50' onClick={this.goBack}>
                Back
              </Button>
            </Col>
            <Col>
              <div className='d-flex flex-row justify-content-end'>
                <Button type='button' color='link' className='btn btn-link printBtn' onClick={this.printPage}>
                  <i className='icon icon-print' />
                  Print Assessment
                </Button>
                <Button type='button' color='primary' className='btn btn-primary awardeeNextBtn' onClick={this.handleSubmit}>
                  Submit
                </Button>
              </div>
            </Col>
          </Row>
          <div className='mb-50' />
        </div>
      </div>
    );
  }

}

UploadVoucherReviewSubmit.propTypes = {
  history: PropTypes.object
}